import React from 'react';
import { connect } from 'react-redux';
import NavBarComponent from '../NavBar/NavBar';
import SideMenuBar from '../SideMenuBar/SideMenuBar';
import './Layout.scss';
import Footer from '../Footer/Footer';

class Layout extends React.Component {
  state= {
    logoFlag: false
  }

  ontoogleMenu = (data) => {
    this.setState({ logoFlag: data });
  }
  render() {
    // const { location } = this.props;
    // const mypath = location.pathname;
    return (
      <div>
        <SideMenuBar ontoogleMenu={this.ontoogleMenu}/>
        <main className="app">
          <div className="app-wrapper">
            <div className="app-container">
            <NavBarComponent router={this.props.router} logoFlag={this.state.logoFlag}/>
            <div style={{minHeight: '90vh'}}>{this.props.children}</div>
            </div>
            <div style={{ backgroundColor: '#4C6575' }}>
              <Footer loadTranslations={this.props.loadTranslations} />
              </div>
          </div>
        </main>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { 
    locale: state.locale
   };
}

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./screens/Layout/Layout.js